import React, { useState } from "react";
import { TileLayer, LayersControl } from "react-leaflet";

const { BaseLayer } = LayersControl;

const MapLayers = () => {
  return (
    <LayersControl position="topright">
      <BaseLayer checked name="OpenStreetMap">
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      </BaseLayer>
      <BaseLayer name="Satellite">
        <TileLayer url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}" subdomains={["mt0", "mt1", "mt2", "mt3"]} />
      </BaseLayer>
      <BaseLayer name="Terrain">
        <TileLayer url="https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}" subdomains={["mt0", "mt1", "mt2", "mt3"]} />
      </BaseLayer>
    </LayersControl>
  );
};

export default MapLayers;
